import { cloneDeep, set } from "lodash";
import moment from "moment";
import React, { FC, HTMLAttributes, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import ApiStateModal from "../../../components/reusable-ui/basic-modal";
import { MESSAGE_TYPE, COMPONENT_MODES } from "../../../data/constants";
import { isAddNewMode, isEditMode } from "../../../helpers/catalog-helper";
import {
  getAllItemSchedulesData,
  saveItemScheduleData,
} from "../../../redux/slices";
import { RootState } from "../../../redux/store";
import ItemScheduleDetailsForm from "./item-schedule-details-form";
import ItemScheduleViewComponent from "./item-schedule-view";
import "./style.scss";

const ItemScheduleManagement: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const INITIAL_ITEM_SCHEDULE_DETAILS = {
    // startDate: moment().format('YYYY-MM-DD'),
    // endDate: moment().format('YYYY-MM-DD')
  };
  const [itemScheduleId, setItemScheduleId] = useState<string>("");
  const [isChangesMade, setIsChangesMade] = useState<boolean>(false);
  const [errorMessageMap, setErrorMsgMap] = useState<any>({});
  const [curItemScheduleDetails, setCurItemScheduleDetails] = useState<any>({});
  const [modeConfig, setModeConfig] = useState<any>({
    //it will determine whether it's in view mode or edit mode
    type: COMPONENT_MODES.viewMode,
    tabId: "",
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalText, setSuccessModalText] = useState("");
  const dispatch = useDispatch();
  const itemSchedulesDataMap = useSelector(
    (state: RootState) => state.itemSchedulesReducer.itemSchedulesDataMap
  );

  useEffect(() => {
    dispatch(getAllItemSchedulesData());
  }, []);

  useEffect(() => {
    if (isAddNewMode(modeConfig.type) || !itemScheduleId) {
      setCurItemScheduleDetails(INITIAL_ITEM_SCHEDULE_DETAILS);
    }
  }, [modeConfig, itemScheduleId]);

  useEffect(() => {
    if (!isAddNewMode(modeConfig?.type) && itemScheduleId) {
      setCurItemScheduleDetails(itemSchedulesDataMap[itemScheduleId]);
      resetStateOnClose();
    }
  }, [itemScheduleId, itemSchedulesDataMap]);

  const updateItemScheduleDataInParentState = (key: string, value: any) => {
    const dataToUpdate = cloneDeep(curItemScheduleDetails) || {};
    set(dataToUpdate, key, value);
    setCurItemScheduleDetails(dataToUpdate);
    setIsChangesMade(true);
  };

  function resetStateOnClose() {
    setErrorMsgMap({});
    setIsChangesMade(false);
    setModeConfig({ type: COMPONENT_MODES.viewMode });
  }

  const onDiscardCtaClick = () => {
    resetStateOnClose();
    if (!isAddNewMode(modeConfig?.type)) {
      if (itemScheduleId) {
        setCurItemScheduleDetails(
          cloneDeep(itemSchedulesDataMap[itemScheduleId])
        );
      } else {
        setCurItemScheduleDetails(INITIAL_ITEM_SCHEDULE_DETAILS);
      }
    }
  };

  const validateItemScheduleDetails = (itemScheduleDetails: any) => {
    if (
      itemScheduleDetails?.name &&
      itemScheduleDetails?.channelDefIds?.length &&
      itemScheduleDetails?.itemHours?.businessDays?.length
    ) {
      return { isValid: true, dataToPost: itemScheduleDetails };
    }
    let errorMsgMap: any = {};

    if (!itemScheduleDetails?.name) {
      errorMsgMap.name = "This is mandatory field";
    }

    if (!itemScheduleDetails?.channelDefIds?.length) {
      errorMsgMap.channelDefIds = "This is mandatory field";
    }

    if (!itemScheduleDetails?.itemHours?.businessDays?.length) {
      errorMsgMap.timelines = "Please add atleast one time slot.";
    }

    return { isValid: false, errorMsgMap };
  };

  const onSaveCtaClick = () => {
    const validatedData: any = validateItemScheduleDetails(
      curItemScheduleDetails
    );
    if (validatedData?.isValid) {
      dispatch(
        saveItemScheduleData({
          dataToPost: curItemScheduleDetails,
          callback: (response: any) => {
            if (isEditMode(modeConfig?.type)) {
              // dispatch(updateItemSchedulesMap({key:itemScheduleId, data: response}))
              // dispatch(getAllItemSchedulesData());
              setSuccessModalText("Changes Saved Successfully");
            } else if (isAddNewMode(modeConfig?.type)) {
              // dispatch(getAllItemSchedulesData());
              setSuccessModalText("Item Schedule Created Successfully");
            }
            dispatch(getAllItemSchedulesData());
            setShowSuccessModal(true);
            resetStateOnClose();
          },
        })
      );
    } else {
      setErrorMsgMap(validatedData?.errorMsgMap);
    }
  };

  const commonProps = {
    data: curItemScheduleDetails,
    modeConfig,
    setModeConfig,
    updateItemScheduleDataInParentState,
    itemScheduleId,
    errorMessageMap,
    onSaveCtaClick,
    onDiscardCtaClick,
    isChangesMade,
    itemSchedulesDataMap,
  };

  return (
    <section className="h-[calc(100vh-141px)] overflow-y-hidden flex sm:flex-col itemScheduleManageContainer">
      <ItemScheduleViewComponent
        openItemScheduleView={setItemScheduleId}
        {...commonProps}
      />

      {itemScheduleId ? <ItemScheduleDetailsForm {...commonProps} /> : null}

      {showSuccessModal && (
        <ApiStateModal
          modalType={MESSAGE_TYPE.success}
          open={showSuccessModal}
          handleClose={() => setShowSuccessModal(false)}
          mainText={successModalText}
        ></ApiStateModal>
      )}
    </section>
  );
};

export default ItemScheduleManagement;
